import { Brand } from '@awazevr/design-system.components.awaze-theme-provider'

export const typeCheckBrand = (
  givenBrandString: string,
): givenBrandString is Brand => {
  const brands: Array<Brand> = [
    'agnostic',
    'awaze',
    'cottages.com',
    'dansommer',
    'fincallorca',
    'hoseasons',
    'jamesVillas',
    'novasol',
  ]
  const isValidBrand = brands.includes(givenBrandString as Brand)

  return isValidBrand
}
